import { SecretManager } from '@api/secret-manager-handler';
import { LoadInitialState, ResetReducerState } from '../types';

export const SET_ACTIVE_SECRET_MANAGERS = 'SET_ACTIVE_SECRET_MANAGERS';

export type SetActiveSecretManagers = {
    type: typeof SET_ACTIVE_SECRET_MANAGERS;
    payload: SecretManager[];
}

export type ActionTypes = SetActiveSecretManagers | ResetReducerState | LoadInitialState;

export type SecretManagerReducerState = {
    activeSecretManagers: SecretManager[];
}
